"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListeningRpcCommunicator = void 0;
const RoutingRpcCommunicator_1 = require("./RoutingRpcCommunicator");
const proto_rpc_1 = require("@streamr/proto-rpc");
const identifiers_1 = require("../identifiers");
class ListeningRpcCommunicator extends RoutingRpcCommunicator_1.RoutingRpcCommunicator {
    transport;
    messageListener;
    disconnectedListener;
    constructor(ownServiceId, transport, options) {
        super(ownServiceId, (msg, opts) => transport.send(msg, opts), options);
        this.messageListener = (msg) => {
            this.handleMessageFromPeer(msg);
        };
        this.disconnectedListener = (peerDescriptor) => {
            const requests = this.getRequestIds((request) => (0, identifiers_1.areEqualPeerDescriptors)(peerDescriptor, request.getCallContext().targetDescriptor));
            requests.forEach((id) => this.handleClientError(id, new proto_rpc_1.RpcError.Disconnected('Peer disconnected')));
        };
        this.transport = transport;
        transport.on('message', this.messageListener);
        transport.on('disconnected', this.disconnectedListener);
    }
    destroy() {
        this.transport.off('message', this.messageListener);
        this.transport.off('disconnected', this.disconnectedListener);
        this.stop();
    }
}
exports.ListeningRpcCommunicator = ListeningRpcCommunicator;
//# sourceMappingURL=ListeningRpcCommunicator.js.map